export const breadcrumbRoot = () => document.querySelector<HTMLElement>("#breadcrumb-container")

export function replaceBreadcrumb(html: string) {
    const root = breadcrumbRoot()
    if (root) {
        root.outerHTML = html
    }
}
